module.exports = __webpack_public_path__ + "static/media/SP.0ec40656.webp";